var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.idx)?_c('div',{attrs:{"id":"base-delete-button-vuex"}},[_c('v-btn',{attrs:{"color":"red","dark":""},on:{"click":function($event){return _vm.doDelete(_vm.idx)}}},[_vm._t("default",[_vm._v("Delete")])],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }